import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, Users, Zap, ArrowRight } from "lucide-react";

/**
 * "Plan with Friends" — AI-powered Gen Z party plan + Split Pay CTA
 * Sits between PartyDNA and OnlineBooking on the landing page.
 */
export const PlanWithFriendsTeaser = () => {
  return (
    <section className="py-12 px-4 bg-gradient-to-br from-[#1E1B4B] via-[#3b0764] to-[#831843] relative overflow-hidden" data-testid="plan-with-friends-teaser">
      {/* Decorative confetti dots */}
      <div className="absolute inset-0 opacity-20 pointer-events-none">
        <div className="absolute top-4 left-8 w-2 h-2 rounded-full bg-[#FF9F1C]"/>
        <div className="absolute top-12 right-12 w-3 h-3 rounded-full bg-[#E83E8C]"/>
        <div className="absolute bottom-8 left-1/3 w-2 h-2 rounded-full bg-white"/>
        <div className="absolute top-1/2 right-8 w-2 h-2 rounded-full bg-[#8B5CF6]"/>
      </div>

      <div className="max-w-5xl mx-auto relative">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div className="text-white">
            <div className="inline-flex items-center gap-1.5 bg-white/10 backdrop-blur px-3 py-1 rounded-full mb-4">
              <Sparkles size={14} className="text-[#FF9F1C]"/>
              <span className="text-xs uppercase tracking-widest font-semibold">New · AI Powered</span>
            </div>
            <h2 className="text-4xl sm:text-5xl font-black font-['Outfit'] leading-tight">
              Plan a premium party,<br/>
              <span className="bg-gradient-to-r from-[#FF9F1C] via-[#E83E8C] to-[#8B5CF6] bg-clip-text text-transparent">split with friends.</span>
            </h2>
            <p className="mt-4 text-base opacity-80 leading-relaxed">
              Upload your room → AI designs Gen-Z decor, reel ideas and captions tailored to your budget. 
              Then <b className="text-[#FF9F1C]">sab milke contribute karo</b> via WhatsApp pay links. DoozyGo books it. ✨
            </p>
            <div className="flex flex-wrap gap-2 mt-5">
              <span className="text-[11px] bg-white/10 px-3 py-1 rounded-full">💸 ₹500/friend vibe</span>
              <span className="text-[11px] bg-white/10 px-3 py-1 rounded-full">🎬 Reel-ready setup</span>
              <span className="text-[11px] bg-white/10 px-3 py-1 rounded-full">📸 AI room preview</span>
            </div>
            <Link
              to="/plan-with-friends"
              className="mt-6 inline-flex items-center gap-2 px-6 py-3.5 rounded-xl bg-gradient-to-r from-[#E83E8C] to-[#FF9F1C] text-white font-bold shadow-2xl hover:scale-[1.02] transition-transform"
              data-testid="plan-with-friends-cta"
            >
              <Users size={18}/> Plan with Friends
              <ArrowRight size={16}/>
            </Link>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-4 text-white">
              <Zap size={20} className="text-[#FF9F1C] mb-2"/>
              <p className="text-sm font-bold">AI Vibe Design</p>
              <p className="text-[11px] opacity-70 mt-1">Gen Z decor list + DIY tips tuned to your budget</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-4 text-white">
              <Users size={20} className="text-[#E83E8C] mb-2"/>
              <p className="text-sm font-bold">Split Pay</p>
              <p className="text-[11px] opacity-70 mt-1">Each friend pays their share · Razorpay secured</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-4 text-white">
              <Sparkles size={20} className="text-[#8B5CF6] mb-2"/>
              <p className="text-sm font-bold">Reel Plan Included</p>
              <p className="text-[11px] opacity-70 mt-1">Hooks, shots & Hinglish captions ready to post</p>
            </div>
            <div className="bg-gradient-to-br from-[#FF9F1C]/20 to-[#E83E8C]/20 border border-[#FF9F1C]/30 rounded-2xl p-4 text-white">
              <div className="text-2xl mb-1">🎉</div>
              <p className="text-sm font-bold">Auto-book when full</p>
              <p className="text-[11px] opacity-70 mt-1">DoozyGo confirms the moment pool hits 100%</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
